window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];
